import { render, staticRenderFns } from "./MemolanguageAureliaRootView.vue?vue&type=template&id=7c058c91&scoped=true&"
import script from "./MemolanguageAureliaRootView.vue?vue&type=script&lang=js&"
export * from "./MemolanguageAureliaRootView.vue?vue&type=script&lang=js&"
import style0 from "./MemolanguageAureliaRootView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MemolanguageAureliaRootView.vue?vue&type=style&index=1&id=7c058c91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c058c91",
  null
  
)

/* custom blocks */
import block0 from "./MemolanguageAureliaRootView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports